import React from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { FAQS } from "../lib/content";

export default function FAQSection() {
  const [open, setOpen] = React.useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="bg-[#FAF7F2] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <p className="kicker">FAQ</p>
            <h2 className="h-section text-[clamp(2rem,4vw,3.2rem)] mt-5">
              The questions every owner asks.
            </h2>
            <p className="font-serif-body text-[#4A4A4A] mt-5 text-[1.02rem] leading-relaxed max-w-md">
              Plain-English answers. No marketing fluff. If yours isn't here,
              the founding-customer form has a notes field.
            </p>
          </div>
          <div className="lg:col-span-8">
            <div data-testid="faq-list">
              {FAQS.map((f, i) => (
                <FAQItem
                  key={f.q}
                  q={f.q}
                  a={f.a}
                  open={open === i}
                  onToggle={() => setOpen(open === i ? -1 : i)}
                  idx={i}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FAQItem({ q, a, open, onToggle, idx }) {
  return (
    <div className="lr-accordion-item" data-testid={`faq-item-${idx}`}>
      <button
        onClick={onToggle}
        className="lr-accordion-trigger"
        data-testid={`faq-trigger-${idx}`}
        aria-expanded={open}
      >
        <span>{q}</span>
        <ChevronDown
          size={20}
          className={`text-[#0B3D5C] mt-1 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>
      <motion.div
        initial={false}
        animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        style={{ overflow: "hidden" }}
      >
        <div className="lr-accordion-content">{a}</div>
      </motion.div>
    </div>
  );
}
